import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { reducer as notificationsReducer } from 'reapop'
import authReducer from 'Features/auth/reducer'
import uiReducer from 'Features/ui/reducer'
import integrationReducer from 'Features/settings/integration/reducer'
// import roomReducer from 'Features/settings/room/reducer'
import roomReducer from 'Features/rooms/reducer'
// import userReducer from 'Features/settings/user/reducer'
import reportReducer from 'Features/report/reducer'
import userReducer from 'Features/user/reducer'
import settingReducer from 'Features/setting/reducer'
import amenityReducer from 'Features/settings/amenity/reducer'
import termReducer from '../src/features/settings/term/reducer'
import faqReducer from '../src/features/settings/faq/reducer'
import contactUsReducer from '../src/features/settings/contact/reducer'
import profileReducer from 'Features/profile/reducer'
import usergroupReducer from 'Features/usergroup/reducer'
import actionReducer from 'Features/action/reducer'
import fbsReducer from 'Features/settings/fbs/reducer'
import locationReducer from 'Features/settings/location/reducer'
import buildingReducer from './features/location/building/reducer'
import floorReducer from './features/location/floor/reducer'
import zoneReducer from './features/location/zone/reducer'
import backgroundReducer from './features/background/reducer'
import fbCategoryReducer from './features/fbCategory/reducer'

export default combineReducers({
    form: formReducer,
    notifications: notificationsReducer(),
    auth: authReducer,
    ui: uiReducer,
    integration: integrationReducer.initialState,
    ini: integrationReducer.ini,
    integrationInfo: integrationReducer.integrationInfo,
    roomsO365: roomReducer.roomsO365,
    roomsCore: roomReducer.roomsCore,
    roomsSubscribe: roomReducer.roomsSubscribe,
    roomCore: roomReducer.roomCore,
    // rooms: roomReducer.rooms,
    // locations: roomReducer.locations,
    // coreRoom: roomReducer.coreRoom,
    // users : userReducer.users,
    // user : userReducer.user,
    allRoomReport: reportReducer.coreRoom,
    roomReport: reportReducer.roomReport,
    users: userReducer.users,
    usersO365: userReducer.usersO365,
    usersAD: userReducer.usersAD,
    user: userReducer.user,
    setting: settingReducer.setting,
    statusSum: reportReducer.statusSum,
    userReport: reportReducer.userReport,
    roomReports: reportReducer.roomReports,
    userSum: reportReducer.userSum,
    roomSum: reportReducer.roomSum,
    amenity: amenityReducer.amenity,
    amenityInfo: amenityReducer.amenityInfo,
    fbs: fbsReducer.fbs,
    fbsInfo: fbsReducer.fbsInfo,
    fbCategory: fbsReducer.fbCategory,
    profileList: profileReducer.profileList,
    profileInfo: profileReducer.profileInfo,
    usergroups: usergroupReducer.usergroups,
    usergroup: usergroupReducer.usergroup,
    actions: actionReducer.actions,
    userStatus: reportReducer.userStatus,
    userSummary: reportReducer.userSummary,
    // roomSummary : reportReducer.roomSummary,
    roomTemp: reportReducer.roomTemp,
    topRoom: reportReducer.topRoom,
    topUser: reportReducer.topUser,
    roomDetail: reportReducer.roomDetail,
    roomsStatus: reportReducer.roomsStatus,
    term: termReducer.term,
    faq: faqReducer.faq,
    contactus: contactUsReducer.contactus,
    coreLocations: locationReducer.coreLocations,
    building: buildingReducer.building,
    buildingInfo: buildingReducer.buildingInfo,
    floor: floorReducer.floor,
    floorinfo: floorReducer.floorInfo,
    zone: zoneReducer.zone,
    zoneInfo: zoneReducer.zoneInfo,
    background: backgroundReducer.background,
    backgroundInfo: backgroundReducer.backgroundInfo,
    fbCategoryInfo: fbCategoryReducer.fbCategoryInfo,
    AD: settingReducer.AD,
    timezone : settingReducer.timezone
})



// WEBPACK FOOTER //
// ./src/reducers.js